// @generated from regex-gen.ts
export var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
export var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// module id = 1026
// module chunks = 7